export default "__VITE_ASSET__Dzrog__c__"